import { render, staticRenderFns } from "./EstimatedCost.vue?vue&type=template&id=55964ae8&scoped=true&"
import script from "./EstimatedCost.vue?vue&type=script&lang=js&"
export * from "./EstimatedCost.vue?vue&type=script&lang=js&"
import style0 from "./EstimatedCost.vue?vue&type=style&index=0&id=55964ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55964ae8",
  null
  
)

export default component.exports